
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import IkoneDivider from "./IkoneDivider.vue";
import { HowItWorksStep } from "@/models/how-it-works.model";
import PostChallengeDialog from "@/components/home/PostChallengeDialog/PostChallengeDialog.vue";

@Component({
  components: {
    IkoneDivider,
    PostChallengeDialog
  }
})
export default class HomeHowItWorksTab extends Vue {
  open: boolean = false;

  @Prop({ required: true })
  items!: Array<HowItWorksStep>;

  @Prop({ required: true })
  challenge!: string;

  solveChallenge() {
    this.$router.push("/challenges");
  }

  get boxStyles() {
    let styles = "d-flex align-center hiw-steps-step ma-4";
    // @ts-ignore
    if (this.$vuetify.breakpoint.smAndDown) {
      styles += " flex-column text-center";
    }
    return styles;
  }
}
